import { Controller } from "@hotwired/stimulus"

/**
 * Lightweight table row filter — hides rows whose text content
 * doesn't match the search term (case-insensitive).
 *
 * Usage:
 *   <div data-controller="inline-search">
 *     <input data-inline-search-target="input"
 *            data-action="input->inline-search#filter"
 *            placeholder="Search...">
 *     <table>
 *       <tr data-inline-search-target="row">...</tr>
 *     </table>
 *     <p class="hidden" data-inline-search-target="empty">No matches.</p>  (optional)
 *   </div>
 */
export default class extends Controller {
  static targets = ["input", "row", "empty"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let shown = 0

    this.rowTargets.forEach((row) => {
      const match = !query || row.textContent.toLowerCase().includes(query)
      row.classList.toggle("hidden", !match)
      if (match) shown += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", shown > 0)
  }
}
